module.exports = __webpack_public_path__ + "static/media/Paper-Authorization.70edd332.png";